import styled from 'styled-components'

const Style = {
	// Prize Editor Styles
	PrizeContainer: styled.div`
		display: flex;
		flex-direction: column;
		gap: 16px;
	`,

	PrizeItem: styled.div`
		border: 1px solid ${({theme}) => theme.color.grey2};
		border-radius: 8px;
		overflow: hidden;
		background-color: ${({theme}) => theme.color.white};
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);

		/* Simplified variant for display-only mode */
		${({$simplified}) =>
			$simplified &&
			`
			margin-bottom: 16px;
			border: none;
			border-radius: 0;
			box-shadow: none;

			&:last-child {
				margin-bottom: 0;
			}
		`}
	`,

	PrizeHeader: styled.div`
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 12px 16px;
		background-color: ${({theme}) => theme.color.grey1};
		border-bottom: 1px solid ${({theme}) => theme.color.grey2};

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 10px 12px;
		}

		/* Simplified variant for display-only mode */
		${({$simplified}) =>
			$simplified &&
			`
			background-color: transparent;
			border-bottom: none;
			padding: 0 0 8px 0;
		`}
	`,

	PrizeTitle: styled.h3`
		margin: 0;
		${({theme}) => theme.font.small_bold};
		color: ${({theme}) => theme.color.black};

		/* Simplified variant for display-only mode */
		${({$simplified}) =>
			$simplified &&
			`
			font-size: inherit;
			font-weight: inherit;
			margin: 0 0 8px 0;
		`}
	`,

	PrizeEditorWrapper: styled.div`
		padding: 16px;

		@media (max-width: ${({theme}) => theme.breakpoints.mobile}) {
			padding: 12px;
		}

		/* No padding for simplified mode */
		${({$simplified}) =>
			$simplified &&
			`
			padding: 0;
		`}
	`,

	RemoveButton: styled.button`
		padding: 6px 12px;
		border: 1px solid ${({theme}) => theme.color.grey3};
		border-radius: 4px;
		background-color: ${({theme}) => theme.color.white};
		color: ${({theme}) => theme.color.grey4};
		${({theme}) => theme.font.extra_small};
		cursor: pointer;
		transition: all 0.2s ease;

		&:hover {
			background-color: ${({theme}) => theme.color.error_light};
			border-color: ${({theme}) => theme.color.error};
			color: ${({theme}) => theme.color.error};
		}

		&:active {
			transform: translateY(1px);
		}
	`,
}

export default Style
